<template>
  <v-container
    v-if="currentUser"
    fluid
    class="px-lg-10"
  >
    <portal to="UserHeaderRightSide">
      <div v-if="canEdit">
        <v-btn
          v-if="!editing"
          class="mr-2"
          color="secondary"
          @click="onEdit"
        >
          <v-icon class="mr-2">
            mdi-square-edit-outline
          </v-icon>
          {{ $t('Edit') }}
        </v-btn>
        <div v-else>
          <v-btn
            class="mr-2"
            color="success"
            @click="onSave"
          >
            <v-icon class="mr-2">
              mdi-content-save-outline
            </v-icon>
            {{ $t('Save') }}
          </v-btn>
          <v-btn
            class="mr-2"
            color="error"
            @click="onCancel"
          >
            <v-icon class="mr-2">
              mdi-cancel
            </v-icon>
            {{ $t('Cancel') }}
          </v-btn>
        </div>
      </div>
    </portal>

    <v-row>
      <v-col
        class="white"
      >
        <div class="d-flex align-center">
          <user-avatar-options
            :user_="currentUser"
            :size="80"
            :editing="editing"
            fetch-update-user
          />
          <h4 class="ml-auto ml-auto secondary--text">
            {{ currentUser.emailAddress }}
          </h4>
        </div>
        <v-divider class="my-6" />
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <div>
                <v-img
                  contain
                  height="20"
                  width="35"
                  :src="imageUrl(currentUser.imageUrl)"
                />
              </div>

              <div v-if="currentUserLaboratory">
                <v-btn
                  text
                  class="text-none"
                  :to="{name: 'Laboratory', params: {laboratoryId: currentUserLaboratory.id}}"
                >
                  {{ $t('Laboratory') }} {{ currentUserLaboratory.name }}
                  <v-icon small>
                    mdi-open-in-new
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col v-if="currentUserCopy">
              <v-text-field
                v-model="currentUserCopy.firstName"
                :disabled="!editing"
                outlined
                color="blue-grey lighten-2"
                :label="$t('First Name')"
                :rules="[v => !!v || '']"
              />

              <v-text-field
                v-model="currentUserCopy.lastName"
                :disabled="!editing"
                outlined
                color="blue-grey lighten-2"
                :label="$t('Last Name')"
                :rules="[v => !!v || '']"
              />

              <v-text-field
                v-model="currentUserCopy.phoneNumber"
                :disabled="!editing"
                outlined
                color="blue-grey lighten-2"
                :label="$t('Phone Number')"
              />
            </v-col>
            <v-col>
              <v-form
                ref="accountForm"
                v-model="formValid"
                lazy-validation
                @submit.prevent
              >
                <v-dialog
                  ref="birthDateModalRef"
                  v-model="birthDateModal"
                  :disabled="!editing"
                  :return-value.sync="currentUserCopy.birthDate"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="currentUserCopy.birthDate"
                      :label="$t('Birth Date')"
                      append-icon="mdi-calendar-account-outline"
                      :disabled="!editing"
                      readonly
                      outlined
                      color="blue-grey lighten-2"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="currentUserCopy.birthDate"
                    :show-current="false"
                    :max="maxDate"
                    color="primary"
                    scrollable
                    no-title
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="birthDateModal = false"
                    >
                      {{ $t('Cancel') }}
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.birthDateModalRef.save(currentUserCopy.birthDate)"
                    >
                      {{ $t('OK') }}
                    </v-btn>
                  </v-date-picker>
                </v-dialog>

                <v-select
                  v-model="currentUserCopy.gender"
                  :items="[$t('male'), $t('female')]"
                  :disabled="!editing"
                  :label="$t('Gender')"
                  outlined
                  color="blue-grey lighten-2"
                  clearable
                />

                <v-text-field
                  v-model="currentUserCopy.position"
                  :disabled="!editing"
                  outlined
                  color="blue-grey lighten-2"
                  :label="$t('Position')"
                  :rules="[v => !!v || '']"
                />
                <!--              <v-autocomplete-->
                <!--                ref="roles"-->
                <!--                v-model="currentUserCopy.groups"-->
                <!--                :items="currentUserCopy.groups"-->
                <!--                disabled-->
                <!--                hide-selected-->
                <!--                outlined-->
                <!--                multiple-->
                <!--                color="blue-grey lighten-2"-->
                <!--                label="Groups"-->
                <!--                item-text="name"-->
                <!--                item-value="id"-->
                <!--                cache-items-->
                <!--                return-object-->
                <!--              >-->
                <!--                <template v-slot:selection="data">-->
                <!--                  <v-chip-->
                <!--                    small-->
                <!--                    color="primary"-->
                <!--                    v-bind="data.attrs"-->
                <!--                    :input-value="data.selected"-->
                <!--                    close-->
                <!--                    @click="data.select"-->
                <!--                    @click:close="removeFromAutocomplete(data.item, 'groups')"-->
                <!--                  >-->
                <!--                    {{ data.item.name }}-->
                <!--                  </v-chip>-->
                <!--                </template>-->
                <!--              </v-autocomplete>-->
              </v-form>
            </v-col>
          </v-row>
        </v-container>

        <!--        <v-divider/>-->
      </v-col>
    </v-row>

    <v-row
      v-if="trainingData"
      class="white my-4"
    >
      <v-col>
        <h3>
          {{ $t('Training History') }}
        </h3>

        <v-data-table
          :headers="trainingDataHeaders"
          :items="trainingData"
        >
          <template v-slot:item.date="{ item }">
            {{ item.date.format('MM/DD/YYYY') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import Me from "@/mixins/Me";
import Laboratory from "@/mixins/laboratory/Laboratory";
import User from "@/mixins/User";
import ImageGetUpload from "@/mixins/ImageGetUpload";

import UserAvatarOptions from "@/components/user/UserAvatarOptions";

export default {
  name: "Account",

  components: {
    UserAvatarOptions
  },

  mixins: [
    Me,
    User,
    ImageGetUpload,
    Laboratory,
  ],

  data: () => {
    return {
      editing: false,

      maxDate: new Date().toISOString(),
      birthDateModal: false,
      currentUserCopy: {},
      formValid: true,
    }
  },

  computed: {
    currentUser() {
      if (this.me.id == this.$route.params.userId) {
        return this.me;
      } else {
        return this.user;
      }
    },

    currentUserLaboratory() {
      return this.currentUser?.laboratory || null;
    },

    currentUserCountry() {
      return this.currentUser?.country || null;
    },

    canEdit() {
      // TODO: check role access
      // if (this.currentUser.id === this.me.id) {
      //
      // }
      return true
    },

    trainingData() {
      if (this.currentUser?.metadata?.training && this.currentUserLaboratory) {
        let user = this.laboratoryUsers.find(u => u.id === this.currentUser.id);
        if (user) return this.generateTrainingData(user)
      }
      return false
    },

    trainingDataHeaders() {
      return [
        {
          text: this.$t('Module name'),
          value: 'trainingModuleName',
          align: 'start',
          sortable: true,
          divider: true,
        },
        {
          text: this.$t('Laboratory'),
          value: 'labName',
          align: 'start',
          sortable: true,
          divider: true,
        },

        {
          text: this.$t('Date'),
          value: 'date',
          align: 'start',
          sortable: true,
        },
      ]
    }
  },

  watch: {
    currentUser() {
      this.currentUserCopy = JSON.parse(JSON.stringify(this.currentUser));
    }
  },

  created() {
    try {
      if (this.currentUser?.laboratory?.id) {
        this.setGlobalLoading(true);
        this.getOneLab(this.currentUser.laboratory.id);
      }
    } catch (e) {
      console.error(e)
    }
    this.setGlobalLoading(false);

  },


  mounted() {
    this.currentUserCopy = JSON.parse(JSON.stringify(this.currentUser));
  },

  methods: {

    onEdit() {
      this.editing = true;
      this.currentUserCopy = JSON.parse(JSON.stringify(this.currentUser));
    },

    onCancel() {
      this.editing = false;
      this.currentUserCopy = JSON.parse(JSON.stringify(this.currentUser));
    },

    async onSave() {
      if (this.$refs.accountForm.validate()) {
        this.setGlobalLoading(true);

        try {
          let updateData = {
            id: this.currentUserCopy.id,
            data: {
              firstName: this.currentUserCopy.firstName,
              lastName: this.currentUserCopy.lastName,
              birthDate: this.currentUserCopy.birthDate,
              gender: this.currentUserCopy.gender || '',
              phoneNumber: this.currentUserCopy.phoneNumber,
              position: this.currentUserCopy.position,
              // emailIsConfirmed: this.selectedForEdit.emailIsConfirmed,
              // laboratory: this.selectedForEdit?.laboratory?.id || null,
              // country: this.selectedForEdit?.country?.id || null,
              // groups: toId(this.selectedForEdit.groups),
              // roles: toId(this.selectedForEdit.roles),
            },

          };

          await this.updateUser(updateData);
          this.editing = false;

        } catch (e) {
          console.error(e)
        }

        this.setGlobalLoading(false);
      }
    },

    removeFromAutocomplete(item, key) {
      const index = this.currentUserCopy[key].findIndex((e) => e.id === item.id);
      if (index >= 0) this.currentUserCopy[key].splice(index, 1);
      this.$refs[key].isMenuActive = false
    },
  },

  // watch: {
  //     me: {
  //         handler: function (val, oldVal) {
  //             console.log("ME-- val: ", val);
  //             console.log("oldVal: ", oldVal);
  //             this.currentUser = this.me
  //         },
  //         deep: true
  //     },
  //     user: {
  //         handler: function (val, oldVal) {
  //             console.log("val: ", val);
  //             console.log("oldVal: ", oldVal);
  //             this.currentUser = this.user
  //         },
  //         deep: true
  //     },
  // },


}
</script>

<style scoped>

</style>
